import * as SwitchPrimitive from "@radix-ui/react-switch";
import { clsx } from "clsx";

// dynamic classes with colors must be specified in Tailwind safelist
//  |-> tailwind.config.js
export enum SwitchColor {
  GREEN = "green",
  ORANGE = "orange",
  PURPLE = "purple",
}

export const Switch = ({
  name,
  color = "green",
  children,
  checked,
  onCheckedChange,
  disabled = false,
  label,
}: {
  name: string;
  color?: string;
  children: React.ReactNode;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
}) => (
  <div className="flex items-center justify-between">
    {children}
    <SwitchPrimitive.Root
      className={clsx(
        "group",
        `data-[state=checked]:bg-${color}-500`,
        "data-[state=unchecked]:bg-neutral-300",
        "relative inline-flex h-[24px] w-[44px] flex-shrink-0 cursor-pointer rounded-md border-2 border-transparent transition-colors duration-200 ease-in-out",
        "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-40",
        `focus:outline-none focus-visible:ring focus-visible:ring-${color}-500 focus-visible:ring-opacity-75`
      )}
      id={name}
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      aria-label={label}
    >
      <SwitchPrimitive.Thumb
        className={clsx(
          "group-data-[state=checked]:translate-x-5",
          "group-data-[state=unchecked]:translate-x-0",
          "pointer-events-none inline-block h-[20px] w-[20px] transform rounded bg-white shadow-lg ring-0 transition duration-200 ease-in-out"
        )}
      />
    </SwitchPrimitive.Root>
  </div>
);

export const SwitchLabel = ({
  name,
  children,
}: {
  name: string;
  children: React.ReactNode;
}) => (
  <label className="text-sm leading-none pr-[15px]" htmlFor={name}>
    {children}
  </label>
);
